import { Injectable } from '@angular/core';
import { ModeModelBase } from '../model';
import { ModelAccessorBase, ModelAccessorInjectables } from '../model_accessor';

export class ExplorationModel extends ModeModelBase {
  override _name = 'result';
  override belongsTo = 'reportRun';
  override attributes = [
    { name: 'state', default: 'new' },
    { name: 'filename', default: '' },
    { name: 'createdAt', default: '' },
  ];
  override initialize(resource) {}
}

@Injectable({ providedIn: 'root' })
export class ExplorationModelAccessor extends ModelAccessorBase<ExplorationModel> {
  override name = 'exploration';
  override parentModel = 'reportRun';
  override parentIdAttribute = 'token';
  override createAttributes = [];
  createModel(resource, opts?) {
    const model = new ExplorationModel(this.injectables.modelInjectables);
    model.$initialize(resource, opts);
    return model;
  }

  constructor(injectables: ModelAccessorInjectables) {
    super(injectables, 'migrated', 'mode.exploration');
  }
}
